import { PageEvent } from '@angular/material/paginator';
import { createAction, props } from '@ngrx/store';
import { HttpException } from '@uzurv/core';
import { Driver } from '@uzurv/dots';
import { DriverOnboardingListState } from './driver-onboarding-list.reducer';
import { TransitProgram } from '@uzurv/clara';

export const FilterTransitProgramDrivers = createAction(
  '[Driver Onboarding List] Filter Transit Program Drivers',
  props<{ transitProgramCodesString?: string; driverStatus?: boolean; filteredSearchString?: string }>()
);
export const RestoreState = createAction('[Driver Onboarding List] Restore state', props<{ state: DriverOnboardingListState }>());

export const RestoreDefaultState = createAction('[Driver Onboarding List] Restore default state');

export const GetSelectedState = createAction('[Driver Onboarding List] Get SelectedState', props<{ payload: string }>());

export const Search = createAction('[Driver Onboarding List] Search', props<{ searchString: string }>());

export const SearchSuccess = createAction('[Driver Onboarding List] Search success', props<{ drivers: Array<Driver> }>());

export const SearchFail = createAction('[Driver Onboarding List] Search failed', props<{ error: HttpException }>());

export const ClearSearch = createAction('[Driver Onboarding List] Clear search');

export const ClearDrivers = createAction('[Driver Onboarding List] Clear drivers');

export const FetchDrivers = createAction('[Driver Onboarding List] Fetch Drivers');

export const FetchDriversSuccess = createAction('[Driver Onboarding List] Fetch Drivers success', props<{ drivers: Array<Driver> }>());

export const FetchDriversFail = createAction('[Driver Onboarding List] Fetch Drivers failed', props<{ error: HttpException }>());

export const SelectedTransitPrograms = createAction(
  '[Driver Onboarding List] Transit Programs selected',
  props<{ transitPrograms: Array<TransitProgram> }>()
);

export const SelectedTransitProgramChips = createAction(
  '[Driver Onboarding List] Selected Transit Program chips',
  props<{ transitProgramChips: Array<string> }>()
);

export const SelectedDriverStatusChips = createAction(
  '[Driver Onboarding List] Selected Driver Status chips',
  props<{ driverStatusChips: Array<string> }>()
);

export const RemoveTransitProgramChip = createAction(
  '[Driver Onboarding List] Remove Selected Transit Program Chip',
  props<{ transitProgramChip: string }>()
);

export const RemoveDriverStatusChip = createAction(
  '[Driver Onboarding List] Remove Selected Driver Status Chip',
  props<{ driverStatus: string }>()
);

export const DriverSelected = createAction('[Driver Onboarding List] Driver selected');

export const PageResults = createAction('[Driver Onboarding List] Page results', props<{ pageEvent: PageEvent }>());

export const SetApprovalMode = createAction(
  '[Driver Onboarding List] Set approval mode',
  props<{ payload: 'Document Approval' | 'Driver Approval' | 'Search Drivers' }>()
);
